/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chrome': {
    width: 16,
    height: 16,
    viewBox: '0 0 80 80',
    data: '<path pid="0" d="M40 0C26.788 0 15.089 6.387 7.809 16.242l12.355 21.4c1.187-9.96 9.57-17.5 19.6-17.631a2 2 0 0 1 .236-.012h34.646C67.736 8.041 54.823 0 40 0zM5.355 19.996A39.842 39.842 0 0 0-.001 40c0 20.602 15.522 37.53 35.526 39.75L47.86 58.385A20 20 0 0 1 39.998 60a20 20 0 0 1-17.145-9.746 2 2 0 0 1-.176-.254L5.354 19.996h.001zM40 24c-8.837 0-16 7.163-16 16 0 8.836 7.163 16 16 16s16-7.164 16-16c0-8.837-7.163-16-16-16zm11.967 0A20 20 0 0 1 60 40a20 20 0 0 1-2.531 9.691 2 2 0 0 1-.146.309l-17.32 30C62.117 79.999 80 62.114 80 40a39.911 39.911 0 0 0-3.329-16H51.967z"/>'
  }
})
